import React, { Suspense } from 'react';
import { Box } from '@gluestack-ui/themed';

import type { TrendChartChartProps } from './TrendChartChart';

const TrendChartChart = React.lazy(() => import('./TrendChartChart'));

export type TrendChartProps = TrendChartChartProps;

/**
 * Lazy-loaded score progression chart (Recharts in a separate chunk).
 */
export function TrendChart({ testID, ...chartProps }: TrendChartProps) {
  return (
    <Suspense
      fallback={(
        <Box height={300} width="100%" testID={`${testID ?? 'trend-chart'}-loading`} />
      )}
    >
      <TrendChartChart testID={testID} {...chartProps} />
    </Suspense>
  );
}
